<template>
  <div class="userPage">
    <personal :setUp="true" :page="userPage"></personal>
  </div>
</template>

<script>
import personal from "./page/personal.vue";
export default {
  name: "userPage",
  data() {
    return {
      true: true,
      userPage: "userPage",
    };
  },
  components: {
    personal,
  },
  mounted() {
    if (
      this.$route.query.roleId &&
      this.$route.query.roleId != window.user.roleid
    ) {
      this.$router.push({
        path: "otherHome",
        query: { roleId: this.$route.query.roleId },
      });
    }
  },
};
</script>

<style scoped></style>
